
import Vue from 'vue'
import Colors from './colors'
// import Phones from './phones'
import Misc from './misc'

Vue.mixin(Colors)
// Vue.mixin(Phones)
Vue.mixin(Misc)
